import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  findConfiguracaoAlarmeTanque,
  recordFiltering,
} from '~/store/modules/configuracaoalarmetanque/actions';

import Form from './form';

function ConfiguracaoAlarmeTanqueList() {
  const redux = useSelector((state) => state.configuracaoalarmetanque);

  const status = useMemo(
    () => [
      { label: 'S', value: t('s.geral.opcoes.sim') },
      { label: 'N', value: t('s.geral.opcoes.nao') },
    ],
    []
  );

  const drive = useMemo(
    () => [
      { label: 0, value: t('s.geral.acionamento.naoaciona') },
      { label: 1, value: t('s.geral.acionamento.prioridadebaixa') },
      { label: 2, value: t('s.geral.acionamento.prioridademedia') },
      { label: 3, value: t('s.geral.acionamento.prioridadealta') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'codigolabelsistema',
        label: t('s.configuracao.configuracaoalarmetanque.codigolabelsistema'),
        formatted: (value) => t(value),
        filter: { type: 'text' },
      },
      {
        id: 'nomeapresentacaoconfigalarmetanque',
        label: t(
          's.configuracao.configuracaoalarmetanque.nomeapresentacaoconfigalarmetanque'
        ),
        filter: { type: 'text' },
      },
      {
        id: 'geraalarmeconfigalarmetanque',
        label: t(
          's.configuracao.configuracaoalarmetanque.geraalarmeconfigalarmetanque'
        ),
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
      },
      {
        id: 'acionaioconfigalarmetanque',
        label: t(
          's.configuracao.configuracaoalarmetanque.acionaioconfigalarmetanque'
        ),
        formatted: (value) => drive.find((d) => d.label === value).value || '',
        filter: { type: 'select', options: drive },
      },
    ],
    [status, drive]
  );

  const fieldlist = [
    'codigolabelsistema',
    'nomeapresentacaoconfigalarmetanque',
    'geraalarmeconfigalarmetanque',
    'acionaioconfigalarmetanque',
  ];

  const substituirHeader = {
    codigolabelsistema: t('s.configuracao.alarme.codigolabelsistema'),
    nomeapresentacaoconfigalarmetanque: t(
      's.configuracao.configuracaoalarmetanque.nomeapresentacaoconfigalarmetanque'
    ),
    geraalarmeconfigalarmetanque: t(
      's.configuracao.configuracaoalarmetanque.geraalarmeconfigalarmetanque'
    ),
    acionaioconfigalarmetanque: t(
      's.configuracao.configuracaoalarmetanque.acionaioconfigalarmetanque'
    ),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findConfiguracaoAlarmeTanque}
      form={Form}
      keys="idconfigalarmetanque"
      detach="idconfigalarmetanque"
      excel
      pdf
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'configuracaoalarmetanques',
          formato,
          fields: fieldlist,
          redux,
          headers: substituirHeader,
          title: 'Relatório de Alarme Tanques',
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          substituirValores: {
            codigolabelsistema: {
              's.configalarme.alteracaomodo': t('s.configalarme.alteracaomodo'),
              's.configalarme.nivelagua': t('s.configalarme.nivelagua'),
              's.configalarme.falhacomunicacao': t(
                's.configalarme.falhacomunicacao'
              ),
              's.configalarme.nivelmuitoalto': t(
                's.configalarme.nivelmuitoalto'
              ),
              's.configalarme.nivelalto': t('s.configalarme.nivelalto'),
              's.configalarme.nivelbaixo': t('s.configalarme.nivelbaixo'),
              's.configalarme.nivelmuitobaixo': t(
                's.configalarme.nivelmuitobaixo'
              ),
            },
            geraalarmeconfigalarmetanque: {
              S: t('s.geral.opcoes.sim'),
              N: t('s.geral.opcoes.nao'),
            },
            acionaioconfigalarmetanque: {
              0: t('s.geral.acionamento.naoaciona'),
              1: t('s.geral.acionamento.prioridadebaixa'),
              2: t('s.geral.acionamento.prioridademedia'),
              3: t('s.geral.acionamento.prioridadealta'),
            },
          },
        })
      }
    />
  );
}

export default ConfiguracaoAlarmeTanqueList;
